import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import DataTable from '../DataTable/DataTable';
import {
  disableAutomaticRecurringPaymentRaw,
  getFailedAutomaticRecurringPayments,
  retryAutomaticRecurringPayment,
} from '../../redux/modules/payment';
import { renderTableColumns } from './options';

import styles from './FailedPayments.module.scss';

const FailedPayments = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const tableRef = useRef();
  const { data, total, loading } = useSelector(
    (state) => state.paymentReducer.failedAutomaticRecurringPayments, shallowEqual,
  );

  const loadData = useCallback((params) => {
    dispatch(getFailedAutomaticRecurringPayments(
      {
        page: params.page,
        perPage: params.limit,
      },
    ));
  }, [dispatch]);

  const handleRetryPayment = useCallback((id) => {
    dispatch(disableAutomaticRecurringPaymentRaw(id));
    dispatch(retryAutomaticRecurringPayment(id));
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <p className="header" id={styles.headerTitle}>{t('headerTitles.failedPayments')}</p>
      <DataTable
        ref={tableRef}
        data={data}
        totalCount={total}
        columns={renderTableColumns(t, handleRetryPayment)}
        loading={loading}
        onParamsChanges={loadData}
      />
    </div>
  );
};

export default FailedPayments;
